<template>
  <div>
    <v-card height="775px" style="position:relative;padding-bottom:50px">
      <v-toolbar
        color="grey darken-3"
        dark
        flat
      >
        <v-toolbar-title>Tru-Point Vendor Integrations</v-toolbar-title>
        <template v-slot:extension>
          <v-tabs
            v-model="tab"
            align-with-title
            background-color="transparent"
            grow
          >
            <v-tabs-slider color="red"></v-tabs-slider>

            <v-tab @click="refreshTab('active')">Active</v-tab>
            <v-tab @click="refreshTab('completed')">Completed</v-tab>
            <v-tab @click="refreshTab('aborted')">Aborted</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items
        v-model="tab"
      >
        <v-tab-item>
          <Active ref="active"/>
        </v-tab-item>
        <v-tab-item>
          <Completed ref="completed"/>
        </v-tab-item>
        <v-tab-item>
          <Aborted ref="aborted"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import Active from '../components/tru_point/Active.vue';
import Completed from '../components/tru_point/Completed.vue';
import Aborted from '../components/tru_point/Aborted.vue';

export default {
  components: {
    Active,
    Completed,
    Aborted,
  },

  data() {
    return {
      tab: 0,
    };
  },

  methods: {
    refreshTab(tab) {
      if (this.$refs[tab]) {
        // this.$refs[tab].getData();
      }
    },
  },
};
</script>

<style scoped>
</style>
